module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Welcome to Shadowtools!")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n      Click on the navigation links above to access the tools.\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0304011b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 109
// module chunks = 2